export const BUSINESS_PARTNER_LIST_QUERY_KEY = '/v2/business-partner-ledger/business-partners' as const;
export const BUSINESS_PARTNER_DETAIL_QUERY_KEY = '/v2/business-partner-ledger/business-partners/{businessPartnerId}/profile-header' as const;
export const businessPartnerComboboxQueryKey = {
  all: [BUSINESS_PARTNER_LIST_QUERY_KEY] as const,
  list: (searchText: string) => [...businessPartnerComboboxQueryKey.all, {
    searchText
  }] as const,
  detail: (businessPartnerId: string) => [BUSINESS_PARTNER_DETAIL_QUERY_KEY, {
    businessPartnerId
  }] as const
} as const;